if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
  constructor() {
    super();
    this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
    this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
    this.errorElement = this.querySelector('.js-cart-terms-error');
    this.submitHandler = this.handleSubmit.bind(this);
    this.changeHandler = this.handleChange.bind(this);
    this.form.addEventListener('submit', this.submitHandler);
    this.cartTermsCheckbox.addEventListener('change', this.changeHandler);
  }

  disconnectedCallback() {
    this.form.removeEventListener('submit', this.submitHandler);
    this.cartTermsCheckbox.removeEventListener('change', this.changeHandler);
    }
    // Handles cart form submit; blocks checkout until the terms checkbox is checked.
    handleSubmit(evt) {
      if (this.cartTermsCheckbox.checked) {
        return;
      }
      evt.preventDefault();
      this.showError();
      }

      // Clears the error state once the shopper checks the box.
      handleChange() {
        if (this.cartTermsCheckbox.checked) {
        this.hideError();
        }
        }
        showError() {
          this.cartTermsCheckbox.setAttribute('aria-invalid', 'true');
          this.cartTermsCheckbox.focus();
          if (!this.errorElement) {
            alert(theme.strings.cartTermsConfirmation); // eslint-disable-line no-alert
            return;
            }
            this.errorElement.textContent = theme.strings.cartTermsConfirmation;
            this.errorElement.hidden = false;
            this.errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            hideError() {
              this.cartTermsCheckbox.removeAttribute('aria-invalid');
              if (this.errorElement) {
                this.errorElement.hidden = true;
                }
                }
              }
              customElements.define('cart-terms', CartTerms);
            }